export default __webpack_public_path__ + "static/media/ponnanigirls.e71d42cf.jpg";